import React from 'react';
import theme from '@theme';

interface AskLogoProps {
  className?: string;
  fill?: string;
}

const AskLogo = ({ fill, className, ...props }: AskLogoProps) => (
  <svg
    width="124px"
    height="17px"
    viewBox="0 0 124 17"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.55643 0.0195312L0 16.6082H2.06125L2.7101 14.6706H8.39917L9.03009 16.6082H11.1021L5.55643 0.0195312ZM3.31055 12.862L5.55643 6.08141L7.8023 12.862H3.31055Z"
      fill={fill}
    />
    <path
      d="M27.2354 0.0162801H29.1461V7.15539L34.586 0.0126953H36.9645L30.7807 8.13045L36.9358 16.5977H34.6057L29.1461 9.10014V16.6013H27.2354V0.0162801Z"
      fill={fill}
    />
    <path
      d="M18.2645 16.5974C16.8539 16.5974 14.7478 15.9324 13.6688 13.4948L15.3411 12.4803C16.0885 14.3121 17.2984 14.6186 18.1838 14.6634C19.9386 14.753 21.3366 13.4284 21.3098 12.0124C21.2309 7.9473 14.2925 9.5031 14.3194 4.07751C14.3373 1.88004 16.3394 0.0195312 18.6749 0.0195312C19.9009 0.0195312 21.9335 0.456876 23.0376 2.88736L21.3456 3.85705C20.738 2.34965 19.7073 1.94098 18.7412 1.94456C17.2876 1.94456 16.3466 3.0666 16.2731 4.09544C16.0276 7.57985 23.4535 6.70158 23.2491 12.0053C23.1505 14.5612 21.0624 16.592 18.2645 16.5974Z"
      fill={fill}
    />
    <path
      d="M59.0774 16.5938H57.1971V1.87826H53.3632V0.00341797H63.0224V1.87826H59.0774V16.5938Z"
      fill={fill}
    />
    <path d="M89.2845 14.7085V16.5942H80.0214V0.00732422H81.9106V14.7085H89.2845Z" fill={fill} />
    <path
      d="M104.658 0.00195312L99.0657 16.5977H101.143L101.796 14.6602H107.52L108.155 16.5977H110.24L104.658 0.00195312ZM102.398 12.857L104.658 6.07279L106.918 12.857H102.396H102.398Z"
      fill={fill}
    />
    <path d="M95.436 0.00878906H93.5433V16.5938H95.436V0.00878906Z" fill={fill} />
    <path
      d="M70.9573 0.00195312L65.3686 16.5995H67.446L68.0984 14.662H73.8234L74.4579 16.5995H76.5424L70.9573 0.00195312ZM68.6971 12.8588L70.9573 6.0728L73.2175 12.8588H68.6953H68.6971Z"
      fill={fill}
    />
    <path
      d="M122.094 0.00358479V11.3351L113.729 0V16.5994H115.62V5.90773L123.98 16.5904V0.00358479H122.094Z"
      fill={fill}
    />
    <path d="M47.1812 0.00878906V16.5938H49.074V0.00878906H47.1812Z" fill={fill} />
  </svg>
);

AskLogo.defaultProps = {
  className: '',
  fill: (theme.palette.text as any).logo,
};

export default AskLogo;
